<template>
  <div>
    <accept-terms-of-service-dialog></accept-terms-of-service-dialog>
    <legal-notice-dialog></legal-notice-dialog>
    <terms-of-service-dialog></terms-of-service-dialog>
    <version-change-log></version-change-log>
  </div>

</template>

<script>
import AcceptTermsOfServiceDialog from '@/views/Common/Dialogs/AcceptTermsOfServiceDialog'
import LegalNoticeDialog from '@/views/Common/Dialogs/LegalNoticeDialog'
import TermsOfServiceDialog from '@/views/Common/Dialogs/TermsOfServiceDialog'
import VersionChangeLog from '@/views/Common/Dialogs/VersionChangeLog'

export default {
  name: 'AppDialogs',
  components: {
    VersionChangeLog,
    TermsOfServiceDialog,
    LegalNoticeDialog,
    AcceptTermsOfServiceDialog
  }
}
</script>